import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getProfileIdByHandleCancelToken,
    getProfileIdByHandle,
    getProfileData,
    getProfileDataCancelToken,
    resetPublicView } from '../../../actions/publicView/view';
import DefaultCoverPhoto from '../../../assets/images/profile/view/cover-page.png';
import Avatar from '../../../components/user/Avatar';
import { decodeString } from '../../../utils/helper';
import { converArrayToString } from '../../../utils/profileHelper';
import LocationIcon from '../../../assets/images/profile/view/map-point-pointer.svg';
import LinkIconEmpty from '../../../assets/images/profile/view/link-empty.svg';
import ReadMoreText from '../../loggedIn/Feed/common/ReadMoreText';
import ChevronDown from '../../../assets/images/chevrons/chevron_down_black.png';
import LoginForm from '../Login/LoginForm';
import { miscLinks,
    profileLinks } from '../../../utils/internalLinks';
import UserName from '../../../components/profile/UserName';
import SuperTaster from '../../../components/misc/SuperTaster';
import SeoHeadMeta from '../../../components/misc/SeoHeadMeta';
import get from 'lodash/get';
const  title = {
    specialisation: "Specialisation",
}

function ProfileView(props) {
    const [viewData, setViewData] = useState(null),
        [showLoginForm, setShowLoginForm] = useState(false);
    useEffect(() => {
        if (props.match.params.currentProfileId) {
            props.getProfileData(props.match.params.currentProfileId)
            .then(res => {
                if (!res) {
                    props.history.replace(miscLinks.notFound);
                } else {
                    window.history.replaceState({}, 'profile', profileLinks.view(res.profile.handle));
                }
            })
        } else {
            props.getProfileIdByHandle(props.match.params.handle)
            .then(res => {
                if (!res) {
                    props.history.replace(miscLinks.notFound);
                }
            })
        }
        return function() {
            if (getProfileIdByHandleCancelToken) getProfileIdByHandleCancelToken();
            if (getProfileDataCancelToken) getProfileDataCancelToken();
            props.resetPublicView();
        }
    }, [props.match.params.handle, props.match.params.currentProfileId]);
    useEffect(() => {
        setViewData(props.publicView.viewData)
    }, [props.publicView]);
    if (!viewData) return <div className="container profile-view profile-view--with-height">
        <div className="profile-view__details profile-view__details--no-margin">
            Fetching...
        </div>
    </div>;
    const { profile,
        seoTags } = viewData,
        heroImageToShow = profile
            && profile.hero_image_meta
            && JSON.parse(profile.hero_image_meta)
            && JSON.parse(profile.hero_image_meta).original_photo
            ? JSON.parse(profile.hero_image_meta).original_photo
            : profile.heroImageUrl
            ? profile.heroImageUrl
            : '',
        imageMeta = get(profile, '.image_meta.original_photo', false),
        imageToShow = profile && imageMeta 
            && JSON.parse(imageMeta)
            ? JSON.parse(imageMeta)
            : '';
    return (<div className="container profile-view">
        { seoTags
            && seoTags.title
            && <SeoHeadMeta title={seoTags.title}>
                <title>{decodeString(seoTags.title)}</title>
            </SeoHeadMeta>}
        <div className="profile-view__background-container">
            <div className="profile-view__background-image__container">
                <img alt="background"
                    src={heroImageToShow || DefaultCoverPhoto}
                    className="profile-view__background-image"/>
            </div>
        </div>
        <div className="profile-view__details">
            <div className="profile-view__details__image__container">
                <Avatar alt={profile.name}
                    className="profile-view__details__image"
                    src={imageToShow} />
            </div>
            <div className="profile-view__details__block">
                <div className="profile-view__details__block__header">
                    <p className="profile-view__details__block__name">
                        <UserName isVerified={!!profile.verified}
                            width={20}
                            height={20}
                            name={profile.name} />
                    </p>
                    <div className="profile-view__details__block__header__action">
                        <button className="profile-view__details__block__follow-btn"
                            onClick={() => setShowLoginForm(true)}>
                            <span className="profile-view__details__block__follow-btn__text">+ Follow</span>
                        </button>
                    </div>
                </div>
                { !!profile.is_tasting_expert && <SuperTaster className="profile-view__details__badge logout" /> }
                <div className="profile-view__details__block__follow__block">
                    {
                        profile.handle
                        && (<><span className="profile-view__details__block__follow__text">@{profile.handle}</span>
                            <span className="profile-view__details__block__follow__separator">&bull;</span>
                        </>)
                    }
                    <span onClick={() => setShowLoginForm(true)} className="profile-view__details__block__follow__text profile-view__details__block__follow__text--link">
                        <span className="profile-view__details__block__follow__text">{profile.followersCount}</span>
                        <span className="profile-view__details__block__follow__text profile-view__details__block__follow__text--secondary">{profile.followersCount === 1 ? 'Follower' : 'Followers'}</span>
                    </span>
                </div>
                {
                    profile.tagline && (<div className="profile-view__details__block__info">
                        <p className="profile-view__details__block__info__text">{decodeString(profile.tagline)}</p>
                    </div>)
                }
                {
                    profile.city && (<div className="profile-view__details__block__info">
                        <img
                            alt="add location"
                            src={LocationIcon}
                            className="profile-view__details__block__info__image"/>
                        <p className="profile-view__details__block__info__text">{profile.city}</p>
                    </div>)
                }
                {
                    profile.website_url && (<div className="profile-view__details__block__info">
                        <img alt="link placeholder"
                            src={LinkIconEmpty}
                            className="profile-view__details__block__info__image"/>
                        <ReadMoreText className="profile-view__details__block__info__text profile-view__details__block__info__text--link"
                            text={profile.website_url} />
                        {/* <a href={profile.website_url}
                            target="_blank"
                            rel="noreferrer noopener"
                            className="profile-view__details__block__info__text profile-view__details__block__info__text--link">{profile.website_url}</a> */}
                    </div>)
                }
                {
                    profile.about && (<div className="profile-view__details__block">
                        <div className="profile-view__details__block__about">
                            <p className="profile-view__details__block__about__title">About</p>
                            <div className="profile-view__details__block__about__description">
                            {
                                profile.about
                                && <ReadMoreText
                                    text={profile.about} />
                            }</div>
                        </div>
                    </div>)
                }
                {
                    profile.profile_specializations && profile.profile_specializations.length && (<div className="profile-view__details__block profile-view__details__block__specialisation">
                        <p className="profile-view__details__block__specialisation__title">{title.specialisation}</p>
                        <ul className="profile-view__details__block__specialisation__list">
                        {
                            profile.profile_specializations.map((specialisation, index) => {
                                return <li key={index} className="profile-view__details__block__specialisation__list__item">
                                    { specialisation.image && <img className="profile-view__details__block__specialisation__list__icon" src={specialisation.image} alt={specialisation.name} /> }
                                    <p>{specialisation.name}</p>
                                </li>
                            })
                        }
                        </ul>
                    </div>)
                }
                {
                    (profile.foodie_type
                    || (profile.cuisines && !!profile.cuisines.length)
                    || (profile.allergens && !!profile.allergens.length)
                    || (profile.profile_occupations && !!profile.profile_occupations.length))
                    && (<div className="profile-view__details__block">
                        {
                            profile.foodie_type && (<div className="profile-view__details__block__personal__block">
                                <p className="profile-view__details__block__personal__title">Eating Habit</p>
                                <div className="profile-view__details__block__personal__description">
                                    { profile.foodie_type.name }
                                </div>
                            </div>)
                        }
                        {
                            profile.allergens && !!profile.allergens.length
                            && (<div className="profile-view__details__block__personal__block">
                                <p className="profile-view__details__block__personal__title">Allergens</p>
                                <div className="profile-view__details__block__personal__description">
                                { converArrayToString(profile.allergens) }
                                </div>
                            </div>)
                        }
                        {
                            profile.cuisines && !!profile.cuisines.length
                            && (<div className="profile-view__details__block__personal__block">
                                <p className="profile-view__details__block__personal__title">Cuisines</p>
                                <div className="profile-view__details__block__personal__description">
                                { converArrayToString(profile.cuisines) }
                                </div>
                            </div>)
                        }
                        {
                            profile.profile_occupations && profile.profile_occupations.length
                            && (<div className="profile-view__details__block__personal__block">
                                <p className="profile-view__details__block__personal__title">Job Profile</p>
                                <div className="profile-view__details__block__personal__description">
                                    { converArrayToString(profile.profile_occupations) }
                                </div>
                            </div>)
                        }
                    </div>)
                }
                <button onClick={() => setShowLoginForm(true)} className="profile-view__show-more">Show More
                    <img src={ChevronDown} alt="show more" />
                </button>
            </div>
        </div>
        { showLoginForm && <LoginForm shouldOnlyToggle={true}
            toggleLoginForm={() => setShowLoginForm(false)} /> }
    </div>)
}

const mapDispatchToProps = {
    getProfileIdByHandle,
    resetPublicView,
    getProfileData
}

function mapStateToProps(state) {
    return {
        publicView: state.publicView
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileView);